// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import dotsVerticalIcon from "@/assets/icons/dots-vertical.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type DotsVerticalIconProps = Omit<IconProps, "name">;

export function DotsVerticalIcon(props: DotsVerticalIconProps): React.ReactNode {
  return <Icon name={dotsVerticalIcon} {...props} />;
}
